$(document).ready(function() {

	ub.data.threadColors = {};
    ub.data.twillColors = {};

	ub.data.materialOptionWithLimitedColors = {
        
        items: [
            {
                block_pattern: 'Soccer',
                neck_options: ['Goalie (M)', 'Goalie (W)', 'Jersey (M)', 'Jersey (W)', 'Short (W)', 'Short (M)'],
                material_option: 'Pro-Dry',
                valid_colors: [
                    'B',
                    'W',
                    'GR',
                ]
            },
            {
                block_pattern: 'Quarter Zip Jacket',
                neck_options: ['Long Sleeve', 'Short Sleeve'],
                material_option: 'Zipper',
                valid_colors: [
                    'B',
                    'W',

                ]
            },
            {
                block_pattern: 'Cage Jacket (Apparel)',
                neck_options: ['Long Sleeve', 'Short Sleeve'],
                material_option: 'Zipper', 
                valid_colors: [
                    'B',    
                    'W',
                    'R',
                    'GR',
                    'NB',
                    'RB',
                ]
            },
            {
                block_pattern: 'Compression Pant',
                neck_options: ['Full', 'Quarter'],
                material_option: 'Waistband', 
                valid_colors: [
                    'B',    
                    'CG',
                ]
            },
            {
                block_pattern: 'Compression Pant',
                neck_options: ['Full', 'Quarter'],
                material_option: 'Prolook', 
                valid_colors: [
                    'B',    
                    'CG',
                ]
            },
            {
                block_pattern: 'Game Day Jacket',
                neck_options: ["Men's", "Women's"],
                material_option: 'Zipper', 
                valid_colors: [
                    'B',    
                    'W',
                    'R',
                    'GR',
                    'NB',
                    'RB',
                ]
            },
            {
                block_pattern: 'Game Day Jacket',
                neck_options: ["Men's", "Women's"],
                material_option: 'Arm Elastic', 
                valid_colors: [
                    'B',    
                    'W',
                    'R',
                    'GR',
                    'NB',
                    'RB',
                ]
            },

            // SFN Hoodie
            {
                block_pattern: 'SFN Hoodie',
                neck_options: ['Long Sleeve', 'Short Sleeve', 'Sleeveless'],
                material_option: 'Zipper', 
                valid_colors: [
                    'B',    
                    'W',
                    'R',
                    'GR',
                    'NB',
                    'RB',
                ]
            },
            {
                block_pattern: 'SFN Hoodie',
                neck_options: ['Long Sleeve', 'Short Sleeve', 'Sleeveless'],
                material_option: 'Hood Cuff', 
                valid_colors: [
                    'B',    
                    'W',
                    'R',
                    'GR',
                    'NB',
                    'RB',
                ]
            },
            {
                block_pattern: 'SFN Hoodie',
                neck_options: ['Long Sleeve', 'Short Sleeve', 'Sleeveless'],
                material_option: 'Arm Cuff', 
                valid_colors: [
                    'B',    
                    'W',
                    'R',
                    'GR',
                    'NB',
                    'RB',
                ]
            },
            {
                block_pattern: 'SFN Quarter Zip Hoodie Womens',
                neck_options: ['Long Sleeve', 'Short Sleeve', 'Sleeveless'],
                material_option: 'Zipper', 
                valid_colors: [
                    'B',    
                    'W',
                    'R',
                    'GR',
                    'NB',
                    'RB',
                ]
            },
            {
                block_pattern: 'SFN Quarter Zip Hoodie Womens',
                neck_options: ['Sleeveless'],
                material_option: 'Arm Cuff', 
                valid_colors: [
                    'B',    
                    'W',
                    'R',
                    'GR',
                    'NB',
                    'RB',
                ]
            },
            {
                block_pattern: 'SFN Quarter Zip Hoodie Womens',
                neck_options: ['Long Sleeve', 'Short Sleeve', 'Sleeveless'],
                material_option: 'Hood Cuff', 
                valid_colors: [
                    'B',    
                    'W',
                    'R',
                    'GR',
                    'NB',
                    'RB',
                ]
            },
            {
                block_pattern: 'SFN Full Zip Hoodie Womens',
                neck_options: ['Long Sleeve', 'Short Sleeve', 'Sleeveless'],
                material_option: 'Zipper', 
                valid_colors: [
                    'B',    
                    'W',
                    'R',
                    'GR',
                    'NB',
                    'RB',
                ]
            },
            {
                block_pattern: 'SFN Pull Over Hoodie Womens',
                neck_options: ['Long Sleeve', 'Short Sleeve', 'Sleeveless'],
                material_option: 'Zipper', 
                valid_colors: [
                    'B',    
                    'W',
                    'R',
                    'GR',
                    'NB',
                    'RB',
                ]
            },
            {
                block_pattern: 'SFN Full Zip Hoodie Womens',
                neck_options: ['Long Sleeve', 'Short Sleeve', 'Sleeveless'],
                material_option: 'Hood Cuff', 
                valid_colors: [
                    'B',    
                    'W',
                    'R',
                    'GR',
                    'NB',
                    'RB',
                ]
            },
            {
                block_pattern: 'SFN Pull Over Hoodie Womens',
                neck_options: ['Long Sleeve', 'Short Sleeve', 'Sleeveless'],
                material_option: 'Hood Cuff', 
                valid_colors: [
                    'B',    
                    'W',
                    'R',
                    'GR',
                    'NB',
                    'RB',
                ]
            },
            {
                block_pattern: 'SFN Full Zip Hoodie Womens',
                neck_options: ['Sleeveless'],
                material_option: 'Arm Cuff', 
                valid_colors: [
                    'B',    
                    'W',
                    'R',
                    'GR',
                    'NB',
                    'RB',
                ]
            },
            {
                block_pattern: 'SFN Pull Over Hoodie Womens',
                neck_options: ['Sleeveless'],
                material_option: 'Arm Cuff', 
                valid_colors: [
                    'B',    
                    'W',
                    'R',
                    'GR',
                    'NB',
                    'RB',
                ]
            },
            // End SFN Hoodie

            // Team Store
            {
                block_pattern: 'Cage Jacket (Apparel)',
                neck_options: ['Full', 'Quarter'],
                material_option: 'Zipper', 
                valid_colors: [
                    'B',    
                    'W',
                    'R',
                    'GR',
                    'NB',
                    'RB',
                ]
            },

            // After migration. Note: Don't delete the previous ones above so that the old saved designs wont be messed up
            {
                block_pattern: 'Cage Jackets',
                neck_options: ['Long Sleeves', 'Short Sleeves'],
                material_option: 'Zipper', 
                valid_colors: [
                    'B',    
                    'W',
                    'R',
                    'GR',
                    'NB',
                    'RB',
                ]
            },
            {
                block_pattern: 'Quarter Zip Jacket',
                neck_options: ['Long Sleeve', 'Short Sleeve'],
                material_option: 'Zipper',
                valid_colors: [
                    'B',
                    'W',
                ]
            },
            // PTS Cage Jacket
            {
                block_pattern: 'PTS Cage Jacket',
                neck_options: ['Short Sleeve'],
                material_option: 'Zipper', 
                valid_colors: [
                    'B',    
                    'W',
                    'R',
                    'GR',
                    'NB',
                    'RB',
                ]
            },
            {
                block_pattern: 'PTS Cage Jacket',
                neck_options: ['Short Sleeve'],
                material_option: 'Neck Tape 1', 
                valid_colors: [
                    'W',    
                    'CG',
                ]
            },
            {
                block_pattern: 'PTS Cage Jacket',
                neck_options: ['Short Sleeve'],
                material_option: 'Neck Tape 2', 
                valid_colors: [
                    'W',    
                    'CG',
                ]
            },
            // PTS Hoodie
            {
                block_pattern: 'PTS Hoodie',
                neck_options: ['Hoodie'],
                material_option: 'Neck Tape 1', 
                valid_colors: [
                    'W',    
                    'CG',
                ]
            },
            {
                block_pattern: 'PTS Hoodie',
                neck_options: ['Hoodie'],
                material_option: 'Neck Tape 2', 
                valid_colors: [
                    'W',    
                    'CG',
                ]
            },
            // SFN Jogger
            {
                block_pattern: 'SFN Jogger',
                neck_options: ['SFN Jogger'],
                material_option: 'Zipper', 
                valid_colors: [
                    'B',    
                    'W',
                    'R',
                    'GR',
                    'NB',
                    'RB',
                ]
            },
            // SFN Jogger (Womens)
            {
                block_pattern: 'SFN Jogger (W)',
                neck_options: ['SFN Jogger (W)'],
                material_option: 'Zipper', 
                valid_colors: [
                    'B',    
                    'W',
                    'R',
                    'GR',
                    'NB',
                    'RB',
                ]
            },
            // Flag Football
            {
                block_pattern: 'Flag Football',
                neck_options: ['Flag Jersey'],
                material_option: 'Team Flag', 
                valid_colors: [
                    'FLB',
                    'FLG',
                ]
            },
            // Match Series
            {
                block_pattern: 'Match Series',
                neck_options: ['Jersey (M)', 'Jersey (W)', 'Short (W)', 'Short (M)'],
                material_option: 'Pro-Dry',
                valid_colors: [
                    'B',
                    'W',
                    'GR',
                ]
            },
            // Match Series
            {
                block_pattern: 'Champion Series',
                neck_options: ['Jersey (M)', 'Jersey (W)', 'Short (W)', 'Short (M)'],
                material_option: 'Pro-Dry',
                valid_colors: [
                    'B',
                    'W',
                    'GR',
                ]
            },
            //Premier Series
            {
                block_pattern: 'Premier Series',
                neck_options: ['Jersey (M)', 'Jersey (W)', 'Short (W)', 'Short (M)'],
                material_option: 'Pro-Dry',
                valid_colors: [
                    'B',
                    'W',
                    'GR',
                ]
            },
            //Goalie
            {
                block_pattern: 'Goalie',
                neck_options: ['Goalie (M)', 'Goalie (W)'],
                material_option: 'Pro-Dry',
                valid_colors: [
                    'B',
                    'W',
                    'GR',
                ]
            },

            {
                block_pattern: 'SFN Full Zip Hoodie',
                neck_options: ['Long Sleeve', 'Short Sleeve', 'Sleeveless'],
                material_option: 'Hood Cuff',
                valid_colors: [
                    'B',
                    'W',
                    'R',
                    'RB',
                    'NB',
                    'GR',
                ]
            },

            {
                block_pattern: 'SFN Full Zip Hoodie',
                neck_options: ['Long Sleeve', 'Short Sleeve', 'Sleeveless'],
                material_option: 'Zipper',
                valid_colors: [
                    'B',
                    'W',
                    'R',
                    'RB',
                    'NB',
                    'GR',
                ]
            },

            {
                block_pattern: 'SFN Full Zip Hoodie',
                neck_options: ['Sleeveless'],
                material_option: 'Arm Cuff',
                valid_colors: [
                    'B',
                    'W',
                    'R',
                    'RB',
                    'NB',
                    'GR',
                ]
            },

            {
                block_pattern: 'SFN Pull Over Hoodie',
                neck_options: ['Long Sleeve', 'Short Sleeve', 'Sleeveless'],
                material_option: 'Hood Cuff',
                valid_colors: [
                    'B',
                    'W',
                    'R',
                    'RB',
                    'NB',
                    'GR',
                ]
            },

            {
                block_pattern: 'SFN Pull Over Hoodie',
                neck_options: ['Sleeveless'],
                material_option: 'Arm Cuff',
                valid_colors: [
                    'B',
                    'W',
                    'R',
                    'RB',
                    'NB',
                    'GR',
                ]
            },

            {
                block_pattern: "Face Mask",
                neck_options: ["2-Ply Face Mask"],
                material_option: "Elastic",
                valid_colors: [
                    'B',
                    'W',
                    'GR',
                ]
            },
            // Performance Hoodie
            {
                block_pattern: 'Performance Hoodie',
                neck_options: ['Performance'],
                material_option: 'Hood Cuff',
                valid_colors: [
                    'B',
                    'W',
                    'R',
                    'RB',
                    'NB',
                    'GR',
                ]
            },
            {
                block_pattern: 'Performance Hoodie',
                neck_options: ['Performance'],
                material_option: 'Zipper',
                valid_colors: [
                    'B',
                    'W',
                    'R',
                    'RB',
                    'NB',
                    'GR',
                ]
            },
            {
                block_pattern: 'Triple Crown Tee',
                neck_options: [
                    'Three Quarter Sleeve - Heathered', 
                    'Long Sleeve - Heathered',
                    'Short Sleeve - Heathered'
                ],
                material_option: 'Prolook',
                valid_colors: [
                    'B',
                    'W',
                    'GR'
                ]
            },

        ],

        getLimitedColorSet: function (materialOption) {

            var _result = _.find(this.items, function (item) {

                return item.block_pattern === ub.current_material.material.block_pattern && 
                        _.contains(item.neck_options, ub.current_material.material.neck_option) && 
                        item.material_option === materialOption;

            });

            return _result;

        }

    };

    ub.data.coordinatingColors = {

        items: [
            {
                origin: 'Prolook',
                matchingPart: 'Waistband',
                sport: 'Compression Pant (Apparel)',
                blockPattern: 'Compression Pant',
                neckOption: ['Full', 'Quarter'],
                color1: 'CG',
                color2: 'B',
            },
            {
                origin: 'Waistband',
                matchingPart: 'Prolook',
                sport: 'Compression Pant (Apparel)',
                blockPattern: 'Compression Pant',
                neckOption: ['Full', 'Quarter'],
                color1: 'CG',
                color2: 'B',
            },
            // PTS Cage Jacket
            {
                origin: 'Neck Tape 1',
                matchingPart: 'Neck Tape 2',
                sport: 'PTS Cage Jacket (Apparel)',
                blockPattern: 'PTS Cage Jacket',
                neckOption: ['Short Sleeve'],
                color1: 'CG',
                color2: 'W',
            },
            {
                origin: 'Neck Tape 2',
                matchingPart: 'Neck Tape 1',
                sport: 'PTS Cage Jacket (Apparel)',
                blockPattern: 'PTS Cage Jacket',
                neckOption: ['Short Sleeve'],
                color1: 'CG',
                color2: 'W',
            },
            // PTS Hoodie
            {
                origin: 'Neck Tape 1',
                matchingPart: 'Neck Tape 2',
                sport: 'PTS Hoodie (Apparel)',
                blockPattern: 'PTS Hoodie',
                neckOption: ['Hoodie'],
                color1: 'CG',
                color2: 'W',
            },
            {
                origin: 'Neck Tape 2',
                matchingPart: 'Neck Tape 1',
                sport: 'PTS Hoodie (Apparel)',
                blockPattern: 'PTS Hoodie',
                neckOption: ['Hoodie'],
                color1: 'CG',
                color2: 'W',
            },
        ],

        isCoordinating: function (origin, sport, blockPattern, neckOption, colorCode) {

            var _originOk = _.filter(this.items, function (item) {

                var __originOK = origin === item.origin;

                return origin === item.origin &&
                        sport === item.sport &&
                        blockPattern === item.blockPattern &&
                        _.contains(item.neckOption, neckOption);

            });

            var _matchingPartColor = undefined;
            var _matchingPart = undefined;
            var _firstItem = undefined;

            if (_originOk.length > 0) {

                _firstItem = _originOk[0];

                if (colorCode === _firstItem.color1)  {
                    _matchingPartColor = _firstItem.color2;
                } else {
                    _matchingPartColor = _firstItem.color1;
                }

                _matchingPart = _firstItem.matchingPart;

            }

            return {
                result: (_originOk.length > 0),
                item: (_originOk.length > 0) ? _firstItem : undefined, 
                matchingPart: (_originOk.length > 0) ? _matchingPart : undefined,
                matchingPartColor: (_originOk.length > 0) ? _matchingPartColor : undefined,
            }
            
        }

    }

    ub.data.prolookLogo = {
        items: [
            {
                sports: ['Football 2017', 'Baseball (Quickturn)', 'Fastpitch (Quickturn)', 'Basketball (Quickturn)', 'Football (Quickturn)', 'Tech-Tee (Quickturn)', 'Baseball', 'Track and Field', 'Tech Tee (eSports)', 'Tennis', 'Lacrosse', 'Wrestling 2018', 'Basketball', 'Cage Jacket (Apparel)', 'Quarter Zip Jacket (Apparel)', 'Fastpitch', 'Polo (Apparel)', 'SFN Jogger (Apparel)', 'Soccer', 'Baseball'],
                part: 'Front Body'
            },
            {
                sports: ['Basketball (Quickturn)', 'Tech Tee Hoodie (Quickturn)', 'Volleyball (Quickturn)', 'Football 2017', 'Fastpitch (Quickturn)', 'Baseball (Quickturn)', 'Baseball', 'Tennis', 'Lacrosse', '2017 Team Short with Pockets (Apparel)', 'Wrestling 2018', 'Basketball', 'Field Hockey', 'Fastpitch', '360 Short (Quickturn)', 'Track and Field (Quickturn)', 'Triple Crown Tee (Quickturn)', 'Track and Field', 'Cheer'],
                part: 'Body'
            },
            {
                sports: ['Basketball (Quickturn)', 'Hockey'],
                part: 'Insert'
            },
            {
                sports: ['Basketball (Quickturn)', 'Baseball', 'Hockey'],
                part: 'Insert 1'
            },
            {
                sports: ['Basketball (Quickturn)'],
                part: 'Top Panel 2'
            },
            {
                sports: ['Tech-Tee (Quickturn)', 'Basketball', 'Quarter Zip Jacket (Apparel)'],
                part: 'Front Panel'
            },
            {
                sports: ['Tech-Tee (Quickturn)', 'Tech Tee Hoodie (Quickturn)', 'Track and Field', 'Tech Tee (eSports)', 'Hockey', 'Basketball', 'Tech-Tee (Apparel)', 'Compression (Apparel)', 'Volleyball'],
                part: 'Body Panel'
            },
            {
                sports: ['Tech-Tee (Quickturn)'],
                part: 'Front Shoulder Panel'
            },
            {
                sports: ['Tech-Tee (Quickturn)'],
                part: 'Front Panel Insert 1'
            },
            {
                sports: ['Tech Tee Hoodie (Quickturn)','Volleyball (Quickturn)', 'Football 2017', 'Baseball', 'Track and Field', 'Hoodie (eSports)', 'Tech Tee (eSports)', 'Tennis', 'Lacrosse', 'Signature Coaches Short (Apparel)', 'Wrestling 2018', 'Hockey', 'Tech-Tee (Apparel)', 'Field Hockey', 'Fastpitch', 'Hoodie (Apparel)', 'Polo (Apparel)', 'Compression (Apparel)', 'Volleyball', 'Soccer'],
                part: 'Back Body'
            },
            {
                sports: ['Tech Tee Hoodie (Quickturn)', 'Compression Arm Sleeves (Quickturn)', 'Hockey','Volleyball'],
                part: 'Panel'
            },
            {
                sports: ['Compression Arm Sleeves (Quickturn)'],
                part: 'Compression Sleeve'
            },
            {
                sports: ['Compression Arm Sleeves (Quickturn)'],
                part: 'Panel 2'
            },
            {
                sports: ['Compression Arm Sleeves (Quickturn)', 'Soccer','Team Flag (Apparel)'],
                part: 'Stripes'
            },
            {
                sports: ['Compression Arm Sleeves (Quickturn)'],
                part: 'Base'
            },
            {
                sports: ['Compression Arm Sleeves (Quickturn)','Volleyball'],
                part: 'Insert 2'
            },
            {
                sports: ['Compression Arm Sleeves (Quickturn)'], 
                part: 'Insert 3'
            },
            {
                sports: ['Compression Arm Sleeves (Quickturn)'],
                part: 'Stripe 1'
            },
            {
                sports: ['Compression Arm Sleeves (Quickturn)'],
                part: 'Stripe 2'
            },
            {
                sports: ['Compression Arm Sleeves (Quickturn)','Team Flag (Apparel)'],
                part: 'Stripe 3'
            },
            {
                sports: ['Volleyball (Quickturn)'],
                part: 'Half-tone Fade'
            },
            {
                sports: ['Football 2017', 'Fan Replica Jersey (Apparel)'],
                part: 'Cowl'
            },
            {
                sports: ['Football 2017'],
                part: 'Shoulder Cowl Insert'
            },
            {
                sports: ['Football 2017', 'Track and Field', 'Lacrosse', 'Wrestling 2018', 'Basketball', 'Soccer'],
                part: 'Body Right'
            },
            {
                sports: ['Football 2017'],
                part: 'Cowl Shoulder Panel Insert'
            },
            {
                sports: ['Football 2017'],
                part: 'Cowl Shoulder Panel Insert'
            },
            {
                sports: ['Baseball'],
                part: 'Body Color'
            },
            {
                sports: ['Track and Field'],
                part: 'Side Pattern'
            },
            {
                sports: ['Track and Field'],
                part: 'Back Stripe'
            },
            {
                sports: ['Track and Field', 'Volleyball'],
                part: 'Side Panel'
            },
            {
                sports: ['Track and Field'],
                part: 'Short Panel'
            },
            {
                sports: ['Track and Field'],
                part: 'Brief Panel'
            },
            {
                sports: ['Polo (eSports)', 'Game Day Jackets (Apparel)', 'Polo (Apparel)', 'Game Day Jackets (Apparel)'],
                part: 'Sleeve'
            },
            {
                sports: ['Polo (eSports)'],
                part: 'Shoulder Sleeve Panel'                
            },
            {
                sports: ['Polo (eSports)'],
                part: 'Sleeve Pattern'                
            },
            {
                sports: ['Tech Tee (eSports)', 'Hoodie (eSports)', 'Soccer'],
                part: 'Body Pattern'                
            },
            {
                sports: ['Tech Tee (eSports)', 'Basketball'],
                part: 'Top Panel'                
            }, 
            {
                sports: ['Tech-Tee (Apparel)', 'Fastpitch'],
                part: 'Back Insert'                
            }, 
            {
                sports: ['Game Day Jackets (Apparel)'],
                part: 'Sleeve Bottom Panel'
            },
            {
                sports: ['Game Day Jackets (Apparel)', 'Hockey', 'Field Hockey', 'Polo (Apparel)', 'Game Day Jackets (Apparel)', 'Compression (Apparel)', 'Volleyball'],
                part: 'Shoulder Panel'
            },
            {
                sports: ['Game Day Jackets (Apparel)'],
                part: 'Lower Sleeve Panel'
            },
            {
                sports: ['Tennis'],
                part: 'Upper Panel'
            },
            {
                sports: ['Tennis', 'Wrestling 2018', 'Tech-Tee (Apparel)', 'Polo (Apparel)', 'Volleyball', 'Fastpitch'],
                part: 'Back Panel'
            },
            {
                sports: ['Tennis'],
                part: 'Front Bottom Panel'
            },
            {
                sports: ['Tennis'],
                part: 'Front Stripes'
            },
            {
                sports: ['Lacrosse', 'Volleyball'],
                part: 'Body Left'
            },
            {
                sports: ['Lacrosse'],
                part: 'Front Body Left'
            },
            {
                sports: ['Yoga Pant (Apparel)'],
                part: 'Front Waistband'
            },
            {
                sports: ['Yoga Pant (Apparel)'],
                part: 'Waistband Panel'
            },
            {
                sports: ['Hockey'],
                part: 'Back Body Yoke'
            },
            {
                sports: ['Hockey'],
                part: 'Bottom Cuff'
            },
            {
                sports: ['Basketball'],
                part: 'Front Stripe 1'
            },
            {
                sports: ['Basketball'],
                part: 'Body Stripe 1'
            },
            {
                sports: ['Hockey'],
                part: 'Sleeve Panel 1'
            },
            {
                sports: ['Hockey'],
                part: 'Fire 1'
            },
            {
                sports: ['Hockey', 'Quarter Zip Jacket (Apparel)', 'Polo (Apparel)', 'Soccer'],
                part: 'Back Body Panel'
            },
            {
                sports: ['Tech-Tee (Apparel)'],
                part: 'Back Body Insert 2'
            },
            {
                sports: ['Field Hockey'],
                part: 'Hive Pattern'
            },
            {
                sports: ['Cage Jacket (Apparel)'],
                part: 'Chest Stripes'
            },
            {
                sports: ['Quarter Zip Jacket (Apparel)'],
                part: 'Front Body Panel'
            },
            {
                sports: ['Hoodie (Apparel)'],
                part: 'Body Panel 4'
            },
            {
                sports: ['Hoodie (Apparel)'],
                part: 'Back Panel 4'
            },
            {
                sports: ['SFN Jogger (Apparel)'],
                part: 'Lines'
            },
            {
                sports: ['SFN Jogger (Apparel)'],
                part: 'Body Stripes'
            },
            {
                sports: ['Compression (Apparel)'],
                part: 'Inner Sleeve Piping'
            },
            {
                sports: ['Volleyball'],
                part: 'Top Body Panel'
            },
            {
                sports: ['Volleyball'],
                part: 'Side Panel 1'
            },
            {
                sports: ['Soccer'],
                part: 'Chest Stripe 1'
            },
            {
                sports: ['Soccer'],
                part: 'Chest Stripe 2'
            },
            {
                sports: ['Soccer'],
                part: 'Body Panel 1'
            },
            {
                sports: ['Soccer'],
                part: 'Body Stripes'
            },
            {
                sports: ['Soccer'],
                part: 'Body Stripes 1'
            },
            {
                sports: ['Soccer'],
                part: 'Body Stripes 2'
            },
            {
                sports: ['Soccer'],
                part: 'Body Stripes 3'
            },
            {
                sports: ['Volleyball Short'],
                part: 'Left Body'
            },
            {
                sports: ['Team Flag (Apparel)'],
                part: 'Front Base'
            },
            {
                sports: ['Team Flag (Apparel)'],
                part: 'Stripe 7'
            },
            {
                sports: ['Team Flag (Apparel)'],
                part: 'Bottom Panel'
            },
            {
                sports: ['Volleyball'],
                part: 'Arm Sleeve'
            },
            {
                sports: ['Volleyball'],
                part: 'Inserts'
            },
            
        ],

        conflictingPartCheck: function(sport, material, colorCode) {
            let type = ub.config.type;
            const PROLOOK = ub.current_material.settings[type]['Prolook'] ?? ub.current_material.settings[type]['Prolook Logo'];
            const {code, colorObj} = PROLOOK ?? 'undefined';

            var existItem = _.find(this.items, {part: material});
                // this code is to avoid conflict in colors applied both for compression sleeve part and other conflicting parts 
                existItem = (_.includes([7523,7531,7524], ub.config.material_id) && material === 'Insert 2') ? 'undefined' : existItem;
                existItem = (typeof existItem !== 'undefined') ? _.contains(existItem.sports, sport) : false;

            if (existItem && typeof PROLOOK !== 'undefined') {
                const PROLOOK_COLOR_CODE = colorObj.color_code;

                if (PROLOOK_COLOR_CODE == colorCode) {
                    let teamColors = ub.current_material.settings.team_colors;
                        teamColors = _.without(teamColors, _.findWhere(teamColors, {color_code: colorCode}));
                    let firstColor = _.first(teamColors);

                    ub.funcs.ui.setMaterialOptionColor(code.toTitleCase(), firstColor);
                }
            }
        }, 

        conflictingPatternCheck: function (material, sport, colorCode) {
            let type = ub.config.type;

            const PROLOOK = ub.current_material.settings[type]['Prolook'] ?? 
                            ub.current_material.settings[type]['Prolook Logo'];
            const {code, colorObj} = PROLOOK ?? 'undefined';

            let existItem = _.find(this.items, {part: material});
            existItem = (typeof existItem !== 'undefined') ? _.contains(existItem.sports, sport) : false;
            
            let options = _.uniq(_.map(ub.current_material.materials_options, item => { return item.name }))
            let isExistingPattern = _.contains(options, material)

            if (existItem && typeof PROLOOK !== 'undefined' && isExistingPattern) {

                const PROLOOK_COLOR_CODE = colorObj.color_code;
                let {pattern} = ub.current_material.settings[type][material]
                let colorPattern = _.map(pattern.pattern_obj.layers, item => { return item.colorObj.color_code })

                if (PROLOOK_COLOR_CODE == colorCode) {
                    let teamColors = ub.current_material.settings.team_colors;
                        teamColors = _.without(teamColors, _.findWhere(teamColors, {color_code: colorCode}));
                        teamColors = _.filter(teamColors, item => { return !_.contains(colorPattern, item.color_code)});

                        let firstColor = _.first(teamColors);

                        ub.funcs.ui.setMaterialOptionColor(code.toTitleCase(), firstColor);
                    }
            }
        }
    }

	ub.funcs.prepareColors = function () {

        var items = [
            {
                sports: ['Baseball', 'Basketball', 'Hockey', 'Lacrosse', 'Fastpitch', 'Football 2017'],
                type: ['lower', 'upper'],
                application_type: 'tackle_twill'
            },
        ];

		ub.data.colors = _.filter(ub.data.colors, function (color) {
            if (color.brand.toLowerCase() === ub.config.brand.toLowerCase()) {
                return color = color.active === 1 || color.active === '1';
            }
        });

        // Exclude colors
		ub.data.colors = _.filter(ub.data.colors, function (color) {
			return !ub.data.excludedColors.isExcluded(ub.config.sport, ub.config.uniform_application_type, color.color_code)
                    && color.id !== '148'; //Aqua - old color
		});

        ub.data.colors = _.map(ub.data.colors, function (color) {
            color.order = ub.data.sublimatedColorArrangement.getOrderID(color.name).order;
            return color;
        });
        
        // Stock Volleyball Shorts Exclude Colors
        if (ub.config.blockPattern === 'Stock Volleyball Short') {
            var include_colors = ['B'];
            ub.data.colors = _.filter(ub.data.colors, function(color) {
                return _.contains(include_colors, color.color_code);
            });
        }
        

        // FLB and FLG colors are for Flag Football block pattern only
        if (ub.config.blockPattern !== 'Flag Football') {
            var flag_colors = ['FLB', 'FLG'];
            ub.data.colors = _.filter(ub.data.colors, function(color) {
                return !_.contains(flag_colors, color.color_code);
            });
        }
        
        if (ub.config.blockPattern === 'Sock' || ub.config.blockPattern === 'Crew Sock') {
            var reject_colors = ['AG', 'YB', 'CC', 'BG', 'IB', 'DS', 'AR', 'MO', 'RG', 'UR', 'A', 'CR', 'LV'];
            ub.data.colors = _.filter(ub.data.colors, function(color) {
                return !_.contains(reject_colors, color.color_code);
            });
        }
       
        if (ub.config.blockPattern !== 'Stock Short' && ub.config.blockPattern !== 'Stock Pant' && ub.config.blockPattern !== 'Stock Polo') {
            var reject_colors = ['SL'];
            ub.data.colors = _.filter(ub.data.colors, function(color) {
                return !_.contains(reject_colors, color.color_code);
            });
        }
        
        _.find(items, item => {
            if (_.contains(item.sports, ub.config.sport) && _.contains(item.type, ub.config.type) && item.application_type === ub.config.uniform_application_type ) {
                var reject_colors = ['DR', 'DN', 'AG', 'YB', 'CC', 'BG', 'IB', 'DS', 'AR', 'MO', 'RG', 'BRR', 'SE', 'OP', 'S', 'DP', 'CA', 'A', 'NP', 'DG', 'UR', 'LV'];
                ub.data.colors = _.filter(ub.data.colors, function(color) {
                    return !_.contains(reject_colors, color.color_code);
                });
            }
        });
                    
        ub.data.colors = _.sortBy(ub.data.colors, 'order');

	};

	/**
    * @desc get the colors sets from the backend API
    * @param string name - e.g. 'Thread', 'Sublimation Standard Colors', 'Twill Standard Colors', etc. etc
    * @return array colors
    */
	ub.funcs.getColorsSets = function (name) {

        var colors = [];
        var _url = window.ub.config.api_host + '/api/colors_sets';

        ub.loader(_url, 'colors_sets', function (result) {

            var colorSet = _.find(result, { name: name, active: 1 });

            _.map(JSON.parse(colorSet.colors), function(color) {

                colors.push(ub.funcs.getColorByColorCode(color));

            });

        });

        return colors;

    }

    /**
    * @desc return all thread colors
    * @return array ub.data.threadColors 
    */
    ub.funcs.getThreadColors = function () {

        ub.data.threadColors = ub.funcs.getColorsSets('Thread');

        return ub.data.threadColors;

    }

    ub.funcs.getTwillColors = function () {

        ub.data.twillColors = ub.funcs.getColorsSets('Twill Standard Colors');

        return ub.data.twillColors;

    }

    ub.funcs.getThreadColorsV2 = function() {
        let colors = [];
        let setObject = _.find(ub.data.colors_sets, { name: 'Thread' });

        _.map(JSON.parse(setObject.colors), function(color) {
            colors.push(ub.funcs.getColorByColorCode(color));
        });

        ub.data.threadColors = colors;
    }

    ub.funcs.getTwillColorsV2 = function() {
        let colors = [];
        let setObject = _.find(ub.data.colors_sets, { name: 'Twill Standard Colors' });

        _.map(JSON.parse(setObject.colors), function(color) {
            colors.push(ub.funcs.getColorByColorCode(color));
        });

        ub.data.twillColors = colors;
    }

    ub.funcs.getTeamColors = function() {
        let teamColors = [];
        let {team_colors} = ub.current_material.settings;

        if(team_colors && team_colors.length > 0) {
            teamColors = team_colors;
        }

       return teamColors;
    }
});